module.exports = __webpack_public_path__ + "static/img/completed.12f431b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sign/completed.png
// module id = 418
// module chunks = 2